/*
 * -----------------------------------------------------------------------------
 * REMOVE THIS COMPONENT ONCE NBA PLAYERS ARE SUPPORTED THE ApolloStatsTable
 * -----------------------------------------------------------------------------
 */
import { useAsync } from "@/shared/hooks";
import { playerSeasonStatsLoader } from "../../../loaders/player-loader";
import { NbaLeagueId } from "@suns/api";
import { CURRENT_SEASON_LABEL } from "@/shared/const";
import { StatsTable } from "@/components/StatsTable/StatsTable";

export function TempNbaPlayerStats({
  nbaId,
  measureType = "Base",
  print = false,
}: {
  nbaId: number;
  measureType?: "Base" | "Advanced";
  print?: boolean;
}) {
  const { loading, error, response } = useAsync(playerSeasonStatsLoader, {
    queryParams: {
      scope: "season",
      leagueId: NbaLeagueId.NBA,
      perMode: "PerGame",
      seasonYear: CURRENT_SEASON_LABEL,
      seasonType: "Regular Season",
      grouping: "LeagueYear",
      playerId: nbaId,
      measureType,
      teamGrouping: "Y",
    },
    includeCareerStats: false,
  });

  const stats = (response ?? []) as {
    stats: (string | number | null)[];
    statsHeaders: string[];
    error?: string;
  }[];

  return (
    <StatsTable
      loading={loading}
      error={Boolean(error)}
      stats={stats}
      print={print}
    />
  );
}
